import { Fragment, useCallback, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { FlagIconsTitle, Icons } from "../../../constants";
import IconMarkUp from "../common/IconMarkUp";
import FlagIconBody from "./FlagIconBody";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const FlagIconsContainer = () => {
  const [iconTag, setIconTag] = useState({ iconTag: "" });
  const [icon, setIcon] = useState({ icon: "" });
  const [iconFClass, setIconFClass] = useState({ iconFClass: "" });

  const getIconTag = useCallback((tag: { abbreviation: string }) => {
    setIconTag({
      iconTag: '<i className="flag-icon flag-icon-' + tag.abbreviation + '"></i>',
    });
    setIcon({
      icon: "flag-icon flag-icon-" + tag.abbreviation + " fa-3x",
    });
    setIconFClass({
      iconFClass: "flag-icon flag-icon-" + tag.abbreviation,
    });
  }, []);
  return (
    <>
      <Breadcrumbs mainTitle={FlagIconsTitle} parent={Icons} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={FlagIconsTitle} />
              <CardBody>
                <FlagIconBody getIconTag={getIconTag} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <IconMarkUp iconTag={iconTag} icon={icon} iconFClass={iconFClass} />
    </>
  );
};
export default FlagIconsContainer;
